import { Option } from '@utils/react-select.ts';
import {
  AdminTokenUsage,
  AdminTokenUsageDataValues,
} from '@features/admin-token-usage/types';
import { MultiValue } from 'react-select';
import useSWR from 'swr';
import axiosInstance from '@api/axios.ts';
import { urls } from '@api/urls.ts';
import { backendDateFormat } from '@utils/utils.ts';

interface AdminTokenUsageDataProps {
  interval: string | number;
  selectedDocumentTypes: MultiValue<Option>;
  startDate: Date | null;
  endDate: Date | null;
  category: string | number;
}

const fetcher = async (url: string) => {
  const res = await axiosInstance({
    method: 'GET',
    url,
  });
  return res.data;
};

const useAdminTokenUsageData = ({
  interval,
  selectedDocumentTypes,
  startDate,
  endDate,
  category,
}: AdminTokenUsageDataProps): AdminTokenUsageDataValues => {
  const dateParams = [
    startDate ? `start_date=${backendDateFormat(startDate)}` : null,
    endDate ? `end_date=${backendDateFormat(endDate)}` : null,
  ]
    .filter(Boolean)
    .join('&');

  const baseUrl = `${urls.documentGeneratorTemplate.tokenUsage}?interval=${interval}&category=${category}`;

  const generatedUrls = [
    dateParams ? `${baseUrl}&${dateParams}` : baseUrl,
    // Add document type filters
    ...selectedDocumentTypes.map((dt) =>
      dateParams
        ? `${baseUrl}&document_type=${dt.value}&${dateParams}`
        : `${baseUrl}&document_type=${dt.value}`
    ),
  ];

  const { data, isLoading } = useSWR<AdminTokenUsage[][]>(
    generatedUrls,
    async (fetchUrls: any) => {
      const requests = fetchUrls.map((url: string) => fetcher(url));
      return Promise.all(requests);
    }
  );

  return {
    data,
    isLoading,
    isError: !isLoading && !data,
  };
};

export default useAdminTokenUsageData;
